export enum HabitDayContentStateType {
  Label = 'label',
  Check = 'check',
  Value = 'value',
  Skip = 'skip',
  Fail = 'fail',
}

export type HabitDayContentState =
  | { type: HabitDayContentStateType.Label }
  | { type: HabitDayContentStateType.Check }
  | { type: HabitDayContentStateType.Value; value: number }
  | { type: HabitDayContentStateType.Skip }
  | { type: HabitDayContentStateType.Fail };

export type HabitDayContentStateOptions = {
  completionPercentage: number;
  value: number;
  target: number | null;
  isSkipped: boolean;
  isFailure: boolean;
};

/**
 * Determines what content to display inside a habit day cell/button.
 *
 * - No progress + skipped → skip icon
 * - No progress + failed → fail icon
 * - No value → day label (letter or number)
 * - Value equals target exactly → checkmark
 * - No target and value is 1 → checkmark
 * - Value exists but differs from target → the value number
 *
 * Shared between mobile habit-card day buttons, web habit-week-day buttons,
 * and any future habit day rendering.
 */
export const getHabitDayContentState = ({
  completionPercentage,
  value,
  target,
  isSkipped,
  isFailure,
}: HabitDayContentStateOptions): HabitDayContentState => {
  if (!completionPercentage && isSkipped) {
    return { type: HabitDayContentStateType.Skip };
  }
  if (!completionPercentage && isFailure) {
    return { type: HabitDayContentStateType.Fail };
  }
  if (!value) {
    return { type: HabitDayContentStateType.Label };
  }
  if (target && value === target) {
    return { type: HabitDayContentStateType.Check };
  }
  if (!target && value === 1) {
    return { type: HabitDayContentStateType.Check };
  }
  return { type: HabitDayContentStateType.Value, value };
};
